"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BufferSet = void 0;

var buffer_string_1 = require("./buffer_string");

var cloneDeep = require("lodash.clonedeep");

var BufferSet = /*#__PURE__*/function () {
  function BufferSet(data) {
    _classCallCheck(this, BufferSet);

    this._data = {};
    this._data = {};

    if (data) {
      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;
          this.add(d);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  _createClass(BufferSet, [{
    key: "delete",
    value: function _delete(key) {
      delete this._data[buffer_string_1.keyString(key)];
    }
  }, {
    key: "add",
    value: function add(value) {
      this._data[buffer_string_1.keyString(value)] = value;
    }
  }, {
    key: "has",
    value: function has(value) {
      return this._data[buffer_string_1.keyString(value)] !== undefined;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new BufferSet(cloneDeep(Object.values(this._data)));
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      var index = -1;
      var data = Object.values(this._data);
      return {
        next: function next() {
          index += 1;
          return {
            value: data[index],
            done: !(index in data)
          };
        }
      };
    }
  }, {
    key: "size",
    get: function get() {
      return Object.keys(this._data).length;
    }
  }]);

  return BufferSet;
}();

exports.BufferSet = BufferSet;